import { BaseRequest } from '@trukt/types/BaseRequest';
import { Contact } from '@trukt/types/Contact';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { AxiosInstance } from 'axios';

export type ContactSearchRequest = BaseRequest<Omit<PaginatedQueryParams, 'order'>>;
export type ContactSearchResponse = PaginatedResults<
  Pick<Contact, 'guid' | 'name' | 'email' | 'phoneNumber' | 'mobileNumber'>
>;

export class ContactServices {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search({ queryParams }: ContactSearchRequest) {
    return this.instance.get<ContactSearchResponse>('/contacts', { params: queryParams });
  }
}
